import { apiClient } from '~services/api'
import {
  CategoriesListResponse,
  CountriesListResponse,
  LocationListResponse,
  InterestsListResponse,
  CitiesListResponse,
} from '~types/filters'

export const getCategoriesList = (): Promise<CategoriesListResponse> => {
  return apiClient.get<CategoriesListResponse, CategoriesListResponse>(`/categories`)
}

export const getStatesList = (countryId?: string): Promise<LocationListResponse> => {
  return apiClient.get<LocationListResponse, LocationListResponse>(`/states/by-country`, {
    params: countryId ? { countryId } : undefined,
  })
}

export const getCountriesList = (): Promise<CountriesListResponse> => {
  return apiClient.get<CountriesListResponse, CountriesListResponse>(`/countries`)
}

export const getInterestsList = (): Promise<InterestsListResponse> => {
  return apiClient.get<InterestsListResponse, InterestsListResponse>(`/interests`)
}

export const getCitiesList = (stateId?: string): Promise<CitiesListResponse> => {
  return apiClient.get<CitiesListResponse, CitiesListResponse>(`/cities`, {
    params: stateId ? { stateId } : undefined,
  })
}
